import { render } from "./columnShow.vue?vue&type=template&id=75bc2fd0&scoped=true"
import script from "./columnShow.vue?vue&type=script&lang=js"
export * from "./columnShow.vue?vue&type=script&lang=js"

import "./columnShow.vue?vue&type=style&index=0&id=75bc2fd0&scoped=true&lang=scss"
import "./columnShow.vue?vue&type=style&index=1&id=75bc2fd0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bc2fd0"]])

export default __exports__